<template>
  <div class="pdv-address-form">
    <el-divider content-position="left">Dados do objeto</el-divider>
    <el-row :gutter="5" class="pdv-form-row">
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
        <el-form-item :label="$t('peso-g')" prop="weight" class="is-required">
          <el-input
            type="number"
            v-model="ruleForm.weight"
            v-on:keyup.native.enter="next"
            data-next="type"
            ref="weight"
            :min="0"
            :precision="0"
            :controls="false"
          >
            <i :class="['fa', unlock('weight') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('weight')"></i>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
        <el-form-item :label="$t('tipo')" prop="type">
          <i
            class="fa fa-unlock"
            @click="lock('type')"
            v-if="unlock('type')"
          ></i>
          <i class="fa fa-lock" @click="lock('type')" v-else></i>&nbsp;
          <el-radio
            v-model="ruleForm.type"
            ref="type"
            v-on:keyup.native.enter="next"
            data-next="valuedeclared"
            label="001"
            >Pacote/Caixa</el-radio
          >
          <el-radio
            v-model="ruleForm.type"
            v-on:keyup.native.enter="next"
            data-next="valuedeclared"
            label="003"
            >{{ $t("envelope") }}</el-radio
          >
          <el-radio
            v-model="ruleForm.type"
            v-on:keyup.native.enter="next"
            data-next="valuedeclared"
            label="002"
            >Rolo</el-radio
          >
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="5" class="pdv-form-row">
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
        <el-form-item label="Valor Decl" prop="valuedeclared">
          <el-input
            type="number"
            v-model="ruleForm.valuedeclared"
            v-on:keyup.native.enter="next"
            data-next="warning"
            ref="valuedeclared"
            :min="0"
            :precision="0"
            :controls="false"
          >
            <i :class="['fa', unlock('valuedeclared') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('valuedeclared')"></i>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="additional-services-col">
        <el-form-item>
          <div class="additional-services">
            <div class="additional-service-item">
              <i
                class="fa fa-unlock"
                @click="lock('warning')"
                v-if="unlock('warning')"
              ></i>
              <i class="fa fa-lock" @click="lock('warning')" v-else></i>&nbsp;
              <el-checkbox
                ref="warning"
                v-on:keyup.native.enter="next"
                data-next="ownhand"
                v-model="ruleForm.warning"
                label="1"
              >
                Aviso recebimento
              </el-checkbox>
            </div>
            <div class="additional-service-item">
              <i
                class="fa fa-unlock"
                @click="lock('ownhand')"
                v-if="unlock('ownhand')"
              ></i>
              <i class="fa fa-lock" @click="lock('ownhand')" v-else></i>&nbsp;
              <el-checkbox
                ref="ownhand"
                v-on:keyup.native.enter="next"
                data-next="ardigital"
                v-model="ruleForm.ownhand"
                label="1"
              >
                Mãos próprias
              </el-checkbox>
            </div>
            <div class="additional-service-item">
              <i
                class="fa fa-unlock"
                @click="lock('ardigital')"
                v-if="unlock('ardigital')"
              ></i>
              <i class="fa fa-lock" @click="lock('ardigital')" v-else></i>&nbsp;
              <el-checkbox
                ref="ardigital"
                v-on:keyup.native.enter="next"
                data-next="ap"
                v-model="ruleForm.ardigital"
                label="1"
              >
                A.R. Eletrônico
              </el-checkbox>
            </div>
            <div class="additional-service-item">
              <i
                class="fa fa-unlock"
                @click="lock('ap')"
                v-if="unlock('ap')"
              ></i>
              <i class="fa fa-lock" @click="lock('ap')" v-else></i>&nbsp;
              <el-checkbox
                ref="ap"
                v-on:keyup.native.enter="next"
                data-next="height"
                v-model="ruleForm.ap"
                label="1"
              >
                A.P. (Artigos Perigosos)
              </el-checkbox>
              <ArtigosPerigososPopover style="display: inline-block; vertical-align: middle; margin-left: 5px;" />
            </div>
          </div>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="5" v-if="showAdditionalServiceWarning" class="additional-services-alert">
      <el-col :span="24">
        <el-alert
          class="alert-black-text"
          type="warning"
          title=""
          :closable="false"
          description="Os serviços adicionais A.R - A.R-Eletrônico e MP - Mão própria - Não estão disponíveis para os serviços EXPRESSO 1 e ECONOMICO 1."
        />
      </el-col>
    </el-row>

    <el-row
      :gutter="5"
      v-if="ruleForm.type === '001'"
      style="margin-bottom: 15px"
    >
      <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6">
        <el-form-item :label="$t('altura')" prop="height">
          <el-input
            type="number"
            v-model="ruleForm.height"
            v-on:keyup.native.enter="next"
            data-next="length"
            ref="height"
            :min="0"
            :precision="0"
            :controls="false"
          >
            <i :class="['fa', unlock('height') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('height')"></i>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6">
        <el-form-item :label="$t('largura')" prop="width">
          <el-input
            type="number"
            v-model="ruleForm.width"
            v-on:keyup.native.enter="next"
            data-next="length"
            ref="width"
            :min="0"
            :precision="0"
            :controls="false"
          >
            <i :class="['fa', unlock('width') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('width')"></i>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row
      :gutter="5"
      v-if="ruleForm.type === '002'"
      style="margin-bottom: 15px"
    >
      <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6">
        <el-form-item :label="$t('diametro')" prop="width">
          <el-input
            type="number"
            v-on:keyup.native.enter="next"
            ref="diameter"
            v-model="ruleForm.diameter"
            data-next="width"
            :min="0"
            :precision="0"
            :controls="false"
          >
            <i :class="['fa', unlock('diameter') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('diameter')"></i>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6"
        v-if="ruleForm.type !== '003'"
        style="margin-bottom: 15px"
      >
        <el-form-item :label="$t('comprimento')" prop="length">
          <el-input
            type="number"
            v-on:keyup.native.enter="next"
            ref="length"
            v-model="ruleForm.length"
            data-next="quantity"
            :min="0"
            :precision="0"
            :controls="false"
          >
            <i :class="['fa', unlock('length') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('length')"></i>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6">
        <el-form-item :label="$t('quantidade')" prop="quantity">
          <el-input
            type="number"
            v-model="ruleForm.quantity"
            v-on:keyup.native.enter="calculate"
            ref="quantity"
            :min="0"
            :precision="0"
            :controls="false"
          >
            <i :class="['fa', unlock('quantity') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('quantity')"></i>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-divider content-position="left">Dados da Nota Fiscal</el-divider>
    <el-row :gutter="5">
      <el-col :span="20">
        <el-form-item prop="typeContent">
          <el-radio v-model="ruleForm.typeContent" label="1" value="1">Com nota fiscal</el-radio
          >
          <el-radio v-model="ruleForm.typeContent" label="2"  value="2"
            >Com DC-E</el-radio
          >
          <el-radio v-model="ruleForm.typeContent" label="3"  value="3"
            >Emitir DC-E</el-radio
          >
          <el-radio v-model="ruleForm.typeContent" label="5"  value="5"
            >Isento de DC-E</el-radio
          >
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5" v-if="ruleForm.typeContent === '1'">
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <el-form-item label="Chave NFE" prop="nfeKey">
          <el-input
            v-model="ruleForm.nfeKey"
            placeholder="Digite a chave NFE"
            maxlength="44"
            @input="onNfeKeyInput"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <el-form-item prop="nfeNumber">
          <template slot="label">
            <span v-if="nfeKeyFilled" style="color: #f56c6c">*</span>
            Número
          </template>
          <el-input
            v-model="ruleForm.nfeNumber"
            placeholder="Número da nota"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5" v-if="ruleForm.typeContent === '1'">
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <el-form-item prop="nfeSerie">
          <template slot="label">
            <span v-if="nfeKeyFilled" style="color: #f56c6c">*</span>
            Série
          </template>
          <el-input
            v-model="ruleForm.nfeSerie"
            placeholder="Número de série"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <el-form-item prop="nfeValue">
          <template slot="label">
            <span v-if="nfeKeyFilled" style="color: #f56c6c">*</span>
            Valor da Nota
          </template>
          <el-input
            v-model="ruleForm.nfeValue"
            placeholder="Valor da nota"
            type="number"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5" v-if="ruleForm.typeContent === '2'">
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <el-form-item label="Código DC-E" prop="dceId">
          <el-input
            v-model="ruleForm.dceId"
            placeholder="Digite o código da DC-E"
            maxlength="44"
            @input="onDceIdInput"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <el-form-item label="Número" prop="nfeNumber">
          <el-input
            v-model="ruleForm.nfeNumber"
            placeholder="Preenchido pela DC-E"
            disabled
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5" v-if="ruleForm.typeContent === '2'">
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <el-form-item label="Série" prop="nfeSerie">
          <el-input
            v-model="ruleForm.nfeSerie"
            placeholder="Preenchida pela DC-E"
            disabled
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <el-form-item prop="nfeValue">
          <template slot="label">
            <span v-if="dceIdFilled" style="color: #f56c6c">*</span>
            Valor da DC-E
          </template>
          <el-input
            v-model="ruleForm.nfeValue"
            placeholder="Valor da DC-E"
            type="number"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5" v-if="ruleForm.typeContent === '3'">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-alert 
          class="fs-14"
          type="error" 
          title="Ao emitir a DC-E você deverá informar a Declaração de Conteúdo no botão abaixo. A DC-E é um documento que substitui a nota fiscal e deve conter as informações da descrição do conteúdo, valor declarado e outras informações relevantes para a postagem."
          :closable="false"
        ></el-alert>
      </el-col>
    </el-row>
    <el-row :gutter="5" v-if="ruleForm.typeContent === '5'">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-alert 
          class="fs-14"
          type="info" 
          title="A pré-postagem será enviada com o serviço adicional Isento de Documento Fiscal, sem nota fiscal e sem emissão de DC-E."
          :closable="false"
        ></el-alert>
      </el-col>
    </el-row>
    <el-form-item>
      <el-button type="success" plain @click="calculate">{{
        $t("calcular")
      }}</el-button>
      <el-button type="default" @click="$emit('open')"
        >Declaração de Conteudo</el-button
      >
      <el-button type="default" @click="$emit('volume')">Volumes</el-button>
    </el-form-item>

    <!-- POPUP PARA ADICIONAR VALOR DO SEGURO -->
    <el-dialog
      :visible.sync="showInsuranceDialog"
      width="520px"
      top="15vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="insurance-dialog"
    >
      <div class="insurance-warning-content">
        <h2 class="danger"> ATENÇÃO! </h2>

        <p class="danger">
          Você <strong>ainda não adicionou o valor declarado (seguro)</strong>.
        </p>

        <p class="danger">
          Sem o seguro, a postagem não terá cobertura em caso de extravio.
        </p>

        <p class="highlight">
          Deseja adicionar o valor declarado agora?
        </p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="continueWithoutInsurance">
          NÃO, CONTINUAR SEM
        </el-button>

        <el-button type="success" @click="addInsurance">
          SIM, ADICIONAR SEGURO
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ZipMixins from "@/xpost/mixins/zipcode";
import ArtigosPerigososPopover from "@/components/ArtigosPerigososPopover";
export default {
  mixins: [ZipMixins],
  components: { ArtigosPerigososPopover },
  name: "PdvDeliveryObject",
  computed: {
    showAdditionalServiceWarning() {
      return !!(
        this.ruleForm.warning ||
        this.ruleForm.ownhand ||
        this.ruleForm.ardigital
      );
    },
    nfeKeyFilled() {
      if (!this.ruleForm || !this.ruleForm.nfeKey) return false;
      return String(this.ruleForm.nfeKey).replace(/\D/g, "").length === 44;
    },
    dceIdFilled() {
      if (!this.ruleForm || !this.ruleForm.dceId) return false;
      return String(this.ruleForm.dceId).replace(/\D/g, "").length === 44;
    },
  },
  watch: {
    "ruleForm.typeContent": function (newVal, oldVal) {
      if (newVal === oldVal) return;
      if (!this.ruleForm) return;
      this.ruleForm.nfeKey = "";
      this.ruleForm.nfeNumber = "";
      this.ruleForm.nfeSerie = "";
      this.ruleForm.nfeValue = "";
      this.ruleForm.dceId = "";
    },
  },
  data() {
    return {
      showInsuranceDialog: false,
      locks: [],
      ruleForm: {
        width: 0,
        length: 0,
        height: 0,
        quantity: 1,
        valuedeclared: 0,
        diameter: 0,
        weight: 0,
        type: "001",
        warning: false,
        ownhand: false,
        ardigital: false,
        ap: false,
        nfe: false,
        typeContent: "1",
        dceId: "",
        nfeKey: "",
        nfeNumber: "",
        nfeSerie: "",
        nfeValue: "",
      },
    };
  },
  methods: {
    onNfeKeyInput(value) {
      const key = String(value || "").replace(/\D/g, "");
      if (key.length !== 44) return;
      if (!this.isValidNfeKey(key)) {
        this.$message.warning("Chave NF-e inválida (DV não confere)");
        return;
      }
      // Só preenche se estiver vazio — não sobrescreve digitação manual
      if (!this.ruleForm.nfeSerie) {
        this.ruleForm.nfeSerie = String(parseInt(key.substr(22, 3), 10));
      }
      if (!this.ruleForm.nfeNumber) {
        this.ruleForm.nfeNumber = String(parseInt(key.substr(25, 9), 10));
      }
    },
    onDceIdInput(value) {
      const code = String(value || "").replace(/\D/g, "");
      if (code.length !== 44) return;
      if (!this.isValidNfeKey(code)) {
        this.$message.warning("Código DC-E inválido (DV não confere)");
        return;
      }
      // Campos disabled — sempre sobrescreve, único caminho de preenchimento
      this.ruleForm.nfeSerie = String(parseInt(code.substr(22, 3), 10));
      this.ruleForm.nfeNumber = String(parseInt(code.substr(25, 9), 10));
    },
    isValidNfeKey(key) {
      if (!/^\d{44}$/.test(key)) return false;
      const body = key.substr(0, 43);
      const dv = parseInt(key.charAt(43), 10);
      let sum = 0;
      let weight = 2;
      for (let i = body.length - 1; i >= 0; i--) {
        sum += parseInt(body.charAt(i), 10) * weight;
        weight = weight === 9 ? 2 : weight + 1;
      }
      const mod = sum % 11;
      const calc = mod < 2 ? 0 : 11 - mod;
      return calc === dv;
    },
    startup(form) {
      this.ruleForm = form;
    },
    clear() {
      this.ruleForm = {
        width: this.unlock("width") ? 0 : this.ruleForm.width,
        length: this.unlock("length") ? 0 : this.ruleForm.length,
        height: this.unlock("height") ? 0 : this.ruleForm.height,
        diameter: this.unlock("diameter") ? 0 : this.ruleForm.diameter,
        valuedeclared: this.unlock("valuedeclared")
          ? 0
          : this.ruleForm.valuedeclared,
        weight: this.unlock("weight") ? 0 : this.ruleForm.weight,
        quantity: this.unlock("quantity") ? 1 : this.ruleForm.quantity,
        type: this.unlock("type") ? "001" : this.ruleForm.type,
        warning: this.unlock("warning") ? false : this.ruleForm.warning,
        ownhand: this.unlock("ownhand") ? false : this.ruleForm.ownhand,
        ardigital: this.unlock("ardigital") ? false : this.ruleForm.ardigital,
        ap: this.unlock("ap") ? false : this.ruleForm.ap,
        nfe: false,
        typeContent: "1",
        nfeKey: "",
        nfeNumber: "",
        nfeSerie: "",
        nfeValue: "",
        dceId: "",
      };
    },
    unlock(field) {
      return this.locks.findIndex((x) => x === field) === -1;
    },
    lock(field) {
      const lockIndex = this.locks.findIndex((x) => x === field);
      if (lockIndex !== -1) {
        this.locks.splice(lockIndex, 1);
      } else {
        this.locks.push(field);
      }
    },
    focus() {
      this.$refs.weight.$el.getElementsByTagName("input")[0].select();
      this.$refs.weight.$el.getElementsByTagName("input")[0].scrollIntoView({
        behavior: "smooth",
      });
    },
    calculate() {
      if (!this.ruleForm.valuedeclared || this.ruleForm.valuedeclared <= 0) {
        this.showInsuranceDialog = true;
        return;
      }

      this.$emit("calculate");
    },
    next(el) {
      const ref =
        el.target.dataset.next && this.$refs[el.target.dataset.next]
          ? el.target.dataset.next
          : el.target.parentElement &&
            el.target.parentElement.parentElement &&
            el.target.parentElement.parentElement.dataset &&
            this.$refs[el.target.parentElement.parentElement.dataset.next]
          ? el.target.parentElement.parentElement.dataset.next
          : null;
      if (ref) {
        this.$refs[ref].$el.getElementsByTagName("input")[0].select();
        this.$refs[ref].$el.getElementsByTagName("input")[0].scrollIntoView({
          behavior: "smooth",
        });
      } else {
        this.$emit("focus", "servicesData");
      }
    },
    addInsurance() {
      this.showInsuranceDialog = false;

      this.$nextTick(() => {
        this.$refs.valuedeclared.$el
          .getElementsByTagName("input")[0]
          .focus();
      });
    },

    continueWithoutInsurance() {
      this.showInsuranceDialog = false;
      this.ruleForm.valuedeclared = 0;
      this.$emit("calculate");
    },
  },
};
</script>
<style>
.pdv-address-form {
  width: 100%;
}

.pdv-form-row {
  margin-bottom: 12px;
}

@media (max-width: 767px) {
  .pdv-form-row {
    margin-bottom: 0;
  }
}

.pdv-address-form >>> .el-select,
.pdv-address-form >>> .el-input {
  width: 100%;
}

/* Linha de serviços adicionais (A.R / Mãos próprias / A.R-E / A.P.) */
.additional-services-col {
  margin-bottom: 15px;
}

.additional-services {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
}

.additional-service-item {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

/* cadeado alinhado e clicável junto a cada checkbox */
.additional-service-item > i.fa {
  cursor: pointer;
  width: 16px;
  text-align: center;
}

.additional-services-alert {
  margin-bottom: 15px;
}

.pdv-address-form .lock-toggle {
  cursor: pointer;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  height: 100%;
  line-height: normal;
  text-align: center;
  width: 25px;
}

::v-deep(.alert-black-text .el-alert__description) {
  color: #000000;
  font-size: 14px;
  font-weight: 500;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.insurance-warning-content {
  text-align: center;
  padding: 0px 0px;
}

.insurance-warning-content h2 {
  color: #d32f2f;
  font-size: 24px;
  margin-bottom: 15px;
}

.insurance-warning-content p {
  font-size: 15px;
  margin: 8px 0;
}

.insurance-warning-content .danger {
  color: #b71c1c;
  font-weight: bold;
}

.insurance-warning-content .highlight {
  margin-top: 15px;
  font-size: 17px;
  font-weight: bold;
  color: #c62828;
}

.insurance-dialog {
  font-weight: bold;
  background-color: #FEF0F0;
  border: 2px solid red;
}

</style>